import { createClient, type SupabaseClient } from '@supabase/supabase-js'
import { env } from '@/env'
import type { Database } from '@/types/database'

export type AppSupabaseClient = SupabaseClient<Database>

/**
 * The browser Supabase client, used only for admin work — sign-in and, once the
 * UI exists, reads and writes scoped by RLS to the admin's organization.
 *
 * The public matchmaking form does NOT use this client. It talks to the
 * form-access Edge Function (see src/lib/publicForm.ts), because the `anon`
 * role deliberately has no privileges on any table in this schema.
 */
export const supabase: AppSupabaseClient = createClient<Database>(
  env.supabaseUrl,
  env.supabasePublishableKey,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      // Sessions are read from the URL fragment on magic-link/recovery returns.
      detectSessionInUrl: true,
      storageKey: 'speed-dating-portal.auth',
      flowType: 'pkce',
    },
    global: {
      headers: { 'x-application-name': 'speed-dating-portal' },
    },
  }
)
